import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postPosStations({ body }) {
  return BaseService.post(REST.POS_STATIONS, body);
}

function putPosStations({ body, id }) {
  return BaseService.put(REST.POS_STATIONS_ID(id), body);
}

function getPosStations(params) {
  return BaseService.get(REST.POS_STATIONS, {
    params: paramsFilter({ params }),
  });
}

function deletePosStation({ id }) {
  return BaseService.delete(REST.POS_STATIONS_ID(id));
}

export default {
  postPosStations,
  putPosStations,
  getPosStations,
  deletePosStation,
};
